import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = e(
  (s, r) => /* @__PURE__ */ o.jsx(
    i,
    {
      ref: r,
      ...s,
      image: (t) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...t,
          children: /* @__PURE__ */ o.jsx("path", { fill: "currentColor", d: "M7 9v6h2V9h6V7H9V1H7v6H1v2z" })
        }
      )
    }
  )
);
l.displayName = "PlusIcon";
export {
  l as PlusIcon,
  l as default
};
//# sourceMappingURL=index.js.map
